import React from 'react';

export const ReusableProjectContent = ({
   title,
   description,
   imageUrl,
   linkUrl,
}) => {
   return (
      <div className="container mx-auto grid grid-cols-1 items-center backdrop-blur-sm lg:grid-cols-2 mt-8">
         <div className="flex justify-center items-center order-last lg:order-first">
            <a target="_blank" rel="noopener noreferrer" href={linkUrl}>
               <img src={imageUrl} alt={title} className="w-80 h-72" />
            </a>
         </div>
         <div className="relative order-first lg:order-last">
            <h2 className="title text-center text-2xl text-white capitalize pb-3">
               {title}
            </h2>
            <p className="md:text-sm text-center px-3 pb-3">{description}</p>
            <p className="md:text-sm text-center">
               <a target="_blank" rel="noopener noreferrer" href={linkUrl}>
                  View More
               </a>
            </p>
            <div className="bg-black/30 -z-1 start-0 absolute top-0 h-24 w-24 animate-[spin_10s_linear_infinite] rounded-2xl rounded-br-none rounded-tl-none"></div>
            <div className="bg-black/30 -z-1 end-0 absolute bottom-0 h-24 w-24 animate-ping rounded-full"></div>
         </div>
      </div>
   );
};

export const ReusableProjectContent1 = ({
   title,
   description,
   imageUrl,
   linkUrl,
}) => {
   return (
      <div className="container mx-auto grid grid-cols-1 items-center backdrop-blur-sm lg:grid-cols-2 mt-8">
         <div className="relative ">
            <h2 className="title text-center text-2xl text-white capitalize pb-3">
               {title}
            </h2>
            <p className="md:text-sm text-center px-3 pb-3">{description}</p>
            <p className="md:text-sm text-center">
               <a target="_blank" rel="noopener noreferrer" href={linkUrl}>
                  View More
               </a>
            </p>
            <div className="bg-black/30 -z-1 start-0 absolute top-0 h-24 w-24 animate-[spin_10s_linear_infinite] rounded-2xl rounded-br-none rounded-tl-none"></div>
            <div className="bg-black/30 -z-1 end-0 absolute bottom-0 h-24 w-24 animate-ping rounded-full"></div>
         </div>
         <div className="flex justify-center items-center ">
            <a target="_blank" rel="noopener noreferrer" href={linkUrl}>
               <img src={imageUrl} alt={title} className="w-80 h-72" />
            </a>
         </div>
      </div>
   );
};
